import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import Sidebar from '../../components/shared/Sidebar';

export default function ShopReports() {
  const [data, setData] = useState(null);
  const [shopType, setShopType] = useState('barber');
  const staffLabel = shopType === 'parlour' ? 'Staff' : shopType === 'dentist' ? 'Doctor' : 'Barber';
  const staffIcon = shopType === 'parlour' ? '💄' : shopType === 'dentist' ? '🦷' : '💈';
  const brandLabel = shopType === 'parlour' ? 'ParlourHub' : shopType === 'dentist' ? 'DentistHub19' : 'BarberHub';
  const [loading, setLoading] = useState(false);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  // Get Pakistan date from server
  const [todayStr, setTodayStr] = React.useState('');

  const firstOfMonth = todayStr.slice(0, 8) + '01';

  const loadReport = async (from, to) => {
    setLoading(true);
    try {
      const r = await axios.get('/api/shop/reports', { params: { date_from: from, date_to: to } });
      setData(r.data);
    } catch { toast.error('Report load nahi hui'); }
    setLoading(false);
  };

  useEffect(() => {
    // Get today's date from backend (Pakistan time)
    axios.get('/api/shop/profile').then(r => { if (r.data.shop_type) setShopType(r.data.shop_type); }).catch(() => {});
    axios.get('/api/shop/reports/today').then(r => {
      const t = r.data.today;
      setTodayStr(t);
      setDateFrom(t);
      setDateTo(t);
      loadReport(t, t);
    }).catch(() => {
      const t = new Date().toISOString().split('T')[0];
      setTodayStr(t);
      setDateFrom(t);
      setDateTo(t);
      loadReport(t, t);
    });
  }, []);

  const handleSearch = () => {
    if (!dateFrom || !dateTo) return toast.error('Dates select karein');
    loadReport(dateFrom, dateTo);
  };

  const setPreset = (type) => {
    if (type === 'today') {
      const t = todayStr;
      setDateFrom(t); setDateTo(t);
      loadReport(t, t);
    } else if (type === 'month') {
      setDateFrom(firstOfMonth); setDateTo(todayStr);
      loadReport(firstOfMonth, todayStr);
    } else if (type === 'week') {
      const d = new Date(pkTime);
      d.setDate(d.getDate() - 6);
      const weekFrom = d.toISOString().split('T')[0];
      setDateFrom(weekFrom); setDateTo(todayStr);
      loadReport(weekFrom, todayStr);
    }
  };

  const downloadPDF = () => {
    if (!data) return;
    const s = data.summary;
    const period = dateFrom === dateTo ? dateFrom : `${dateFrom} se ${dateTo}`;
    
    const html = `
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<style>
  body { font-family: Arial, sans-serif; padding: 30px; color: #333; }
  h1 { color: #e94560; border-bottom: 2px solid #e94560; padding-bottom: 10px; }
  h2 { color: #1a1a2e; margin-top: 20px; }
  .summary { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin: 20px 0; }
  .card { border: 1px solid #ddd; border-radius: 8px; padding: 15px; text-align: center; }
  .card .value { font-size: 28px; font-weight: bold; color: #e94560; }
  .card .label { color: #666; margin-top: 5px; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th { background: #1a1a2e; color: white; padding: 10px; text-align: left; }
  td { padding: 10px; border-bottom: 1px solid #eee; }
  tr:nth-child(even) { background: #f9f9f9; }
  .footer { margin-top: 30px; text-align: center; color: #999; font-size: 12px; }
  @media print { body { padding: 10px; } }
</style>
</head>
<body>
<h1>${staffIcon} ${brandLabel} — Sales Report</h1>
<p><strong>Period:</strong> ${period}</p>
<p><strong>Shop:</strong> ${document.title}</p>

<div class="summary">
  <div class="card"><div class="value">PKR ${Number(s.total_revenue).toLocaleString()}</div><div class="label">Total Revenue</div></div>
  <div class="card"><div class="value">${s.total_customers}</div><div class="label">Total Customers</div></div>
  <div class="card"><div class="value">${s.booked_customers}</div><div class="label">Bookings</div></div>
  <div class="card"><div class="value">${s.walkin_customers}</div><div class="label">Walk-ins</div></div>
</div>

${data.per_barber.length > 0 ? `
<h2>${staffIcon} ${staffLabel} Breakdown</h2>
<table>
<tr><th>${staffLabel}</th><th>Customers</th><th>Revenue</th></tr>
${data.per_barber.map(b => `<tr><td>${b.name || 'Unknown'}</td><td>${b.customers}</td><td>PKR ${Number(b.revenue).toLocaleString()}</td></tr>`).join('')}
</table>` : ''}

${data.per_service.length > 0 ? `
<h2>${staffIcon} Service Breakdown</h2>
<table>
<tr><th>Service</th><th>Count</th><th>Revenue</th></tr>
${data.per_service.map(s => `<tr><td>${s.service_name}</td><td>${s.count}</td><td>PKR ${Number(s.revenue).toLocaleString()}</td></tr>`).join('')}
</table>` : ''}

${data.daily.length > 1 ? `
<h2>📅 Daily Breakdown</h2>
<table>
<tr><th>Date</th><th>Customers</th><th>Revenue</th></tr>
${data.daily.map(d => `<tr><td>${new Date(d.booking_date).toLocaleDateString('en-PK')}</td><td>${d.customers}</td><td>PKR ${Number(d.revenue).toLocaleString()}</td></tr>`).join('')}
</table>` : ''}

<div class="footer">Generated by ${brandLabel} Platform — ${new Date().toLocaleString('en-PK')}</div>
</body>
</html>`;

    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const win = window.open(url, '_blank');
    setTimeout(() => {
      win.print();
    }, 500);
  };

  const shareOnWhatsApp = () => {
    if (!data) return;
    const s = data.summary;
    const period = dateFrom === dateTo ? dateFrom : `${dateFrom} se ${dateTo}`;
    let msg = `📊 *Sales Report*\n📅 ${period}\n`;
    msg += `━━━━━━━━━━━━━━━\n`;
    msg += `💰 Total Revenue: PKR ${Number(s.total_revenue).toLocaleString()}\n`;
    msg += `👥 Total Customers: ${s.total_customers}\n`;
    msg += `📱 Bookings: ${s.booked_customers}\n`;
    msg += `🚶 Walk-ins: ${s.walkin_customers}\n`;
    msg += `❌ Cancelled: ${s.cancelled}\n`;
    msg += `━━━━━━━━━━━━━━━\n`;
    if (data.per_barber && data.per_barber.length > 0) {
      msg += `\n${staffIcon} *${staffLabel} Breakdown*\n`;
      data.per_barber.forEach(b => {
        msg += `• ${b.name || 'Unknown'}: ${b.customers} customers — PKR ${Number(b.revenue).toLocaleString()}\n`;
      });
    }
    if (data.per_service && data.per_service.length > 0) {
      msg += `\n${staffIcon} *Services*\n`;
      data.per_service.forEach(s => {
        msg += `• ${s.service_name}: ${s.count}x — PKR ${Number(s.revenue).toLocaleString()}\n`;
      });
    }
    msg += `\n_${brandLabel} Platform_`;
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
  };

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <div className="flex-between page-header">
          <div><h1>📊 Reports</h1><p>Sales aur bookings ka complete hisaab</p></div>
          {data && (
            <div className="flex gap-2">
              <button className="btn btn-whatsapp" onClick={shareOnWhatsApp}>
                📲 WhatsApp Share
              </button>
              <button className="btn" style={{ background: '#dc3545', color: 'white' }} onClick={downloadPDF}>
                📄 PDF Download
              </button>
            </div>
          )}
        </div>

        {/* Date Filters */}
        <div className="card mb-4">
          <div className="flex gap-3" style={{ flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Date From</label>
              <input type="date" className="form-control" value={dateFrom} onChange={e => setDateFrom(e.target.value)} />
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Date To</label>
              <input type="date" className="form-control" value={dateTo} onChange={e => setDateTo(e.target.value)} />
            </div>
            <button className="btn btn-primary" onClick={handleSearch}>🔍 Search</button>
            <div className="flex gap-2">
              <button className="btn btn-outline btn-sm" onClick={() => setPreset('today')}>Aaj</button>
              <button className="btn btn-outline btn-sm" onClick={() => setPreset('week')}>7 Din</button>
              <button className="btn btn-outline btn-sm" onClick={() => setPreset('month')}>Yeh Mahina</button>
            </div>
          </div>
        </div>

        {loading && <div style={{ textAlign: 'center', padding: '60px' }}><div className="spinner" style={{ margin: '0 auto' }} /></div>}

        {data && !loading && (
          <>
            {/* Summary Cards */}
            <div className="grid-4 mb-4">
              <div className="card" style={{ borderTop: '3px solid var(--success)', textAlign: 'center' }}>
                <div style={{ fontSize: '28px', fontWeight: 700, color: 'var(--success)' }}>
                  PKR {Number(data.summary.total_revenue).toLocaleString()}
                </div>
                <div style={{ color: 'var(--text-light)', marginTop: '4px' }}>💰 Total Revenue</div>
              </div>
              <div className="card" style={{ borderTop: '3px solid var(--primary)', textAlign: 'center' }}>
                <div style={{ fontSize: '28px', fontWeight: 700, color: 'var(--primary)' }}>
                  {data.summary.total_customers}
                </div>
                <div style={{ color: 'var(--text-light)', marginTop: '4px' }}>👥 Total Customers</div>
              </div>
              <div className="card" style={{ borderTop: '3px solid var(--accent)', textAlign: 'center' }}>
                <div style={{ fontSize: '28px', fontWeight: 700, color: 'var(--accent)' }}>
                  {data.summary.walkin_customers}
                </div>
                <div style={{ color: 'var(--text-light)', marginTop: '4px' }}>🚶 Walk-ins</div>
              </div>
              <div className="card" style={{ borderTop: '3px solid var(--danger)', textAlign: 'center' }}>
                <div style={{ fontSize: '28px', fontWeight: 700, color: 'var(--danger)' }}>
                  {data.summary.cancelled}
                </div>
                <div style={{ color: 'var(--text-light)', marginTop: '4px' }}>❌ Cancelled</div>
              </div>
            </div>

            <div className="grid-2 mb-4">
              {/* Per Barber */}
              <div className="card">
                <h3 style={{ marginBottom: '16px' }}>{staffIcon} {staffLabel} Breakdown</h3>
                {data.per_barber.length === 0 ? (
                  <p style={{ color: 'var(--text-light)', textAlign: 'center', padding: '20px' }}>Koi data nahi</p>
                ) : (
                  <table>
                    <thead><tr><th>{staffLabel}</th><th>Customers</th><th>Revenue</th></tr></thead>
                    <tbody>
                      {data.per_barber.map((b, i) => (
                        <tr key={i}>
                          <td><strong>{b.name || 'Unknown'}</strong></td>
                          <td>{b.customers}</td>
                          <td style={{ color: 'var(--success)', fontWeight: 600 }}>PKR {Number(b.revenue).toLocaleString()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>

              {/* Per Service */}
              <div className="card">
                <h3 style={{ marginBottom: '16px' }}>✂️ Service Breakdown</h3>
                {data.per_service.length === 0 ? (
                  <p style={{ color: 'var(--text-light)', textAlign: 'center', padding: '20px' }}>Koi data nahi</p>
                ) : (
                  <table>
                    <thead><tr><th>Service</th><th>Count</th><th>Revenue</th></tr></thead>
                    <tbody>
                      {data.per_service.map((s, i) => (
                        <tr key={i}>
                          <td><strong>{s.service_name}</strong></td>
                          <td>{s.count}</td>
                          <td style={{ color: 'var(--success)', fontWeight: 600 }}>PKR {Number(s.revenue).toLocaleString()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>

            {/* Daily Breakdown */}
            {data.daily.length > 1 && (
              <div className="card">
                <h3 style={{ marginBottom: '16px' }}>📅 Daily Breakdown</h3>
                <table>
                  <thead><tr><th>Date</th><th>Customers</th><th>Revenue</th></tr></thead>
                  <tbody>
                    {data.daily.map((d, i) => (
                      <tr key={i}>
                        <td>{new Date(d.booking_date).toLocaleDateString('en-PK', { weekday: 'short', day: 'numeric', month: 'short' })}</td>
                        <td>{d.customers}</td>
                        <td style={{ color: 'var(--success)', fontWeight: 600 }}>PKR {Number(d.revenue).toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
